module.exports = __webpack_public_path__ + "static/media/tron.f2e95287.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/tron.svg
// module id = 858
// module chunks = 7